import { useStore } from "../store/store";
import { useEffect, useState, useContext, useCallback } from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { MdOutlineTouchApp } from "react-icons/md";
import Plates from "./Plates";
// import VR from "./VR";
import Nav from "./Nav";
import { GmContext } from "../pages/Main";
import { MdClose } from "react-icons/md";
import { MdCloudDownload } from "react-icons/md";

const floors = [
  {
    id: 0,
    name: "Lower Ground",
    price: "3,658",
    sqrt: 3658,
    query: "lowerGround",
  },
  {
    id: 1,
    name: "Ground",
    price: "3,941",
    sqrt: 3941,
    query: "ground",
  },
  {
    id: 2,
    name: "First",
    price: "6,523",
    sqrt: 6523,
    query: "first",
  },
  {
    id: 3,
    name: "Second",
    price: "6,538",
    sqrt: 6538,
    query: "second",
  },
  {
    id: 4,
    name: "Third",
    price: "6,533",
    sqrt: 6533,
    query: "third",
  },
  {
    id: 5,
    name: "Fourth",
    price: "6,447",
    sqrt: 6447,
    query: "fourth",
  },
  {
    id: 6,
    name: "Fifth",
    price: "6,547",
    sqrt: 6547,
    query: "fifth",
  },
  {
    id: 7,
    name: "Sixth",
    price: "6,174",
    sqrt: 6174,
    query: "sixth",
  },
  {
    id: 8,
    name: "Seventh",
    price: "4,818",
    sqrt: 4818,
    query: "seventh",
  },
  {
    id: 9,
    name: "Eighth",
    price: "3,436",
    sqrt: 3436,
    query: "eighth",
  },
]

export default function FloorSelector() {
  const { tracks, setTrack, vrModal, setVrModal, showUI, activeMode, setActiveMode } = useStore();
  const [planModal, setPlanModal] = useState(false);
  const { gameManager } = useContext(GmContext);

  const close = () => {
    setPlanModal(false);
  };
  // useEffect(() => {
  //   if (gameManager) {
  //     console.log("gameManager 00", gameManager)
  //     gameManager.studioSceneManager.activeFloorsView();
  //     setTrack(9);
  //   }
  // }, [gameManager]);
  console.log("tracks 00", tracks)


  const onFloorClick = useCallback((floorId) => {
    if (activeMode === "Building") {
      setTrack([floorId])
      gameManager.studioSceneManager.navigateToFloorId(floorId);
    } else if (activeMode === "Availability") {
      if (tracks.includes(floorId)) {
        setTrack([...tracks.filter((track) => track !== floorId)])
        gameManager.studioSceneManager.unCheckHighlightFloorId(floorId);
      } else {
        setTrack([...tracks, floorId])
        gameManager.studioSceneManager.highlightFloorId(floorId);
      }
    }
  }, [activeMode, gameManager, tracks]);

  const onButtonClick = () => {
    // using Java Script method to get PDF file
    fetch('FloorPlans.pdf').then(response => {
      response.blob().then(blob => {
        // Creating new object of PDF file
        const fileURL = window.URL.createObjectURL(blob);
        // Setting various property values
        let alink = document.createElement('a');
        alink.href = fileURL;
        alink.download = 'FloorPlans.pdf';
        alink.click();
      })
    })
  }

  return (
    <StyledFloorSelector
      key="floor"
      animate={{ opacity: 1, transition: { duration: 2 } }}
      initial={{ opacity: 0 }}
      exit={{ opacity: 0, transition: { duration: 1 } }}
      props={{ showUI }}
    >
      {planModal && <Plates close={close} />}
      {/* <div className="instructions">
        <p>
          <MdOutlineTouchApp /> Drag the right side of screen to explore
        </p>
      </div> */}
      <div>
        <button
          onClick={() => {
            if (activeMode !== "Normal") {
              gameManager.studioSceneManager.activeNormalView();
              setActiveMode("Normal");
            }
          }}
          style={{ marginRight: "-6px" }}
          className="close"
        >
          <MdClose />
        </button>
      </div>
      <div>
        {activeMode === "Availability" && <div className="area">
          <h4>Selected: {tracks.map((index) => floors[index]).reduce((sum, floor) => sum + floor.sqrt, 0)} sq. ft.</h4>
        </div>}
        <div className="floors">
          {/* <h3>Floor Plans</h3> */}
          {floors.slice(0).reverse().map((floor) => {
            return <button
              key={floor.id}
              onClick={() => onFloorClick(floor.id)}
              className={tracks.includes(floor.id) && "active" || undefined}
            >
              <p>{floor.name}</p>
              <span>{floor.price}</span>
            </button>
          })}

        </div>
        {activeMode === "Availability" && <a
          // href={`https://blueprint-frost.herokuapp.com/download?sixth=${"true"}`}
          className="download"
          onClick={onButtonClick}
        >
          <MdCloudDownload />
          Download Plans
        </a>}
        <div className="plans">
          <button onClick={() => setPlanModal(true)}>Floor Plans</button>
        </div>
      </div>

      {vrModal && (
        <div className="vr">
          <div className="close">
            <button onClick={() => setVrModal(false)}>X</button>
          </div>
          <h3>360 View</h3>
          <div className="viewer">
            {/* <VR image={"/test.jpg"} /> */}
            <iframe
              src="https://ninety90i.co.uk/7Newgate/"
              frameborder="0"
              title="360 Viewer"
            ></iframe>
          </div>
        </div>
      )}
    </StyledFloorSelector>
  );
}

const StyledFloorSelector = styled(motion.div)`
  .area {
    width: 100%;
    h4 {
      font-size: 1rem;
      color: #fff;
      margin: 0 0 1rem;
      @media (max-width: 768px) {
        font-size: 0.9rem;
      }
    } 
  }
  .download {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    margin: 1rem 0 0;
    font-weight: 500;
    svg {
      margin-right: 0.5rem;
    }
    @media (max-width: 768px) {
      font-size: 0.9rem;
    }
  }
  position: fixed;
  height: 100vh;
  background-color: black;
  padding: 15px 15px 0px 15px;
  bottom: 0rem;
  left: 0rem;
  z-index: 109;
  // background-image: url("/cover.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
  opacity: ${({ props }) => (props.showUI ? 1 : 0)} !important;
  transition: all 0.5s ease;
  h3 {
    font-size: 1.2rem;
    color: #d7b176;
    margin: 0 0 1rem;
  }
  .vr {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url("/cover.png");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    color: #d7b176;
    z-index: 101;
    padding: 2rem;
    * {
      color: #d7b176;
    }
    .viewer {
      background: #000;
      height: 80vh;
      margin-top: 1.5rem;
      overflow: hidden;
      iframe {
        width: 100%;
        height: 100%;
      }
    }
    .close {
      position: absolute;
      top: 2rem;
      right: 2rem;
      button {
        font-size: 1.5rem;
        font-weight: bold;
        cursor: pointer;
        background: transparent;
        border: none;
      }
    }
  }
  .close {
    /* height: 20%; */
    padding: 0.35em;
    border-radius: 50%;
    aspect-ratio: 1;
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.2rem;
    background: #eecd9a;
    color: #fff;
    cursor: pointer;
    @media (max-width: 900px) {
      position: absolute;
      top: 1rem;
      right: 1rem;
      font-size: 1rem;
      padding: 0.5rem;
    }
  }
  .floors {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    // padding: 0em 1.1em;
    // border: 1px solid wheat;
    // margin-bottom: 10px;
    button {
      padding: 0.4rem 1.2rem;
      width: 100%;
      min-width: 200px;
      text-align: left;
      border: none;
      background: transparent;
      border: 1px solid #d7b17680;
      color: #d7b176;
      display: flex;
      justify-content: space-between;
      align-items: center;
      transition: all 0.3s ease-in-out;
      cursor: pointer;
      white-space: nowrap;
      &:not(:last-child) {
        margin-bottom: 0.5rem;
      }
      @media (max-width: 768px) {
        padding: 0.3rem 1rem;
        min-width: auto;
      }
      p {
        margin-right: 0.5rem;
        font-size: 0.9rem;
        @media (max-width: 768px) {
          font-size: 0.8rem;
        }
      }
      span {
        margin-left: 0.5rem;
        font-size: 0.7rem;
        color: inherit;
        @media (max-width: 768px) {
          font-size: 0.6rem;
        }
      }
    }
    .active {
      background: rgb(237, 191, 133);
      background: linear-gradient(
        45deg,
        rgba(237, 191, 133, 1) 0%,
        rgba(249, 213, 155, 1) 100%
      );
      color: #000;
    }
  }
  .instructions {
    position: fixed;
    right: 2rem;
    bottom: 2rem;
    font-weight: 500;
    font-size: 0.8rem;
    p {
      background: #fff;
      display: flex;
      align-items: center;
      line-height: 1;
      padding: 0.5rem 1rem;
      border-radius: 0.25rem;
    }
    svg {
      font-size: 1.2rem;
      color: #e26e40;
      margin-right: 0.5rem;
    }
    @media (max-width: 768px) {
      right: 1rem;
      top: 1rem;
      font-size: 0.7rem;
    }
  }
  .links {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    transition: all 0.7s ease-in-out;
    @media (max-width: 768px) {
      margin-top: 1rem;
    }
    a {
      color: #fff;
      font-size: 1.5rem;
      font-weight: 900;
      margin-bottom: 0.5rem;
      border-bottom: 2px solid transparent;
      padding-bottom: 0.25rem;
      transition: all 0.3s ease;
      @media (max-width: 768px) {
        font-size: 1rem;
      }
      &:hover {
        border-bottom: 2px solid #e26e40;
      }
    }
  }
  .plans {
    transition: all 0.3s ease-in-out;
    color: #fff;
    width: 100%;
    // padding: 0em 1.1em;
    button {
      width: 100%;
      height: 37px;
      color: inherit;
      font-size: 1.1em;
      border: none;
      margin-top: 1rem;
      background: rgb(237, 191, 133);
      background: linear-gradient(
        45deg,
        rgba(237, 191, 133, 1) 0%,
        rgba(249, 213, 155, 1) 100%
      );
      color: #000;
      // padding: .5rem;
      transition: all 0.3s ease;
      cursor: pointer;
      @media (max-width: 768px) {
        font-size: 0.8rem;
      }
    }
  }
  .plan {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #fff;
    z-index: 100;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    button {
      display: block;
      width: 100%;
      height: 20%;
      padding: 3rem;
      border: none;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 3rem;
      background: #e26e40;
      color: #fff;
      cursor: pointer;
    }
    div {
      padding: 2rem;
      height: 80%;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        object-position: center;
      }
    }
  }
`;
